import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DateFormatterService {
  private datePipe = new DatePipe('en-US'); // Puedes especificar el idioma que necesites

  formatDate(dateString: string, format: string): string | null {
    return this.datePipe.transform(dateString, format);
  }

  formatTime(timeString: string, format: string): string | null {
    // Convierte la cadena de tiempo a un objeto Date
    const timeParts = timeString.split(':');
    if (timeParts.length !== 3) {
      throw new Error('Formato de tiempo inválido');
    }

    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
    const seconds = parseInt(timeParts[2], 10);

    // Usa la fecha actual como referencia, y solo cambia la hora
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);

    // Formatea la fecha usando DatePipe
    return this.datePipe.transform(date, format);
  }
}
